<app-multi-select-btn 
    [label]="'Templates'"
    [list]="templates"
    [selected]="selected"
    (onClosed)="closedEvent($event)">
</app-multi-select-btn>